import { useState } from "react";
import {
  defaultTransactionsNav,
  TransactionsNav,
  TransactionsNavContext,
} from "./TransactionsNavTypes";
import { deserializeTransactionsNav } from "./transactionsNavSerialization";

function readInitialNavFromUrl(): TransactionsNav {
  if (typeof window === "undefined") return defaultTransactionsNav;
  if (window.location.pathname.replace(/\/+$/, "") !== "/transactions") {
    return defaultTransactionsNav;
  }
  const navParam = new URLSearchParams(window.location.search).get("nav");
  if (!navParam) return defaultTransactionsNav;
  const parsed = deserializeTransactionsNav(navParam);
  return parsed ?? defaultTransactionsNav;
}

export function TransactionsNavProvider({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  const [nav, setNav] = useState<TransactionsNav>(readInitialNavFromUrl);
  return (
    <TransactionsNavContext.Provider value={[nav, setNav]}>
      {children}
    </TransactionsNavContext.Provider>
  );
}
